import React from "react";
import './App.scss';
import {createBrowserRouter, RouterProvider } from "react-router-dom";
import {routes} from "./routes";
import {ThemeProvider} from "./contexts/ThemeProvider";

import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";
import {numericFormatter} from "react-number-format";


if (!String.prototype.toDollarFormat) {
  String.prototype.toDollarFormat = function(props) {
    return numericFormatter(this, {prefix: "$", thousandSeparator: ",", decimalScale: 2, fixedDecimalScale: true, ...props})
  };
}

if (!Number.prototype.toDollarFormat) {
  Number.prototype.toDollarFormat = function(props) {
    return String(this).toDollarFormat(props)
  };
}

function App() {
  return (
    <ThemeProvider>
      <RouterProvider router={createBrowserRouter(routes)}/>
    </ThemeProvider>
  )
}

export default App;
